<template>
  <n-form-item
    :label="label"
    :label-style="labelStyle"
    :path="path"
    class="flex-1"
    :rule="rule"
  >
    <template v-slot:label>
      <span class="mr-1">
        {{ label }}
      </span>
      <help-text v-if="help"> {{ help }}</help-text>
    </template>
    <n-date-picker
      v-bind="$attrs"
      style="width: 100%"
      clearable
      :type="type"
      v-model:value="input"
      @update:value="onInput"
      @keydown.enter.prevent
    >
    </n-date-picker>
  </n-form-item>
</template>

<script>
import moment from "moment-timezone";
import HelpText from "../HelpText.vue";

export default {
  components: { HelpText },
  inheritAttrs: false,
  props: {
    help: { type: String, default: "" },
    value: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "date",
    },
    path: {},
    customRules: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
    label: { type: String, default: "" },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      input: null,
    };
  },
  computed: {
    format() {
      return this.type == "date" ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss";
    },
    rule() {
      let { rules } = this;
      const vm = this;
      let settings = this.settings || {};
      return {
        trigger: ["submit", "blur", "input"],
        required: settings.is_required || false,
        validator() {
          for (let rule of rules) {
            let msg = rule({ v: vm.input, ...vm.settings });
            if (msg) return new Error(msg);
          }
        },
      };
    },
  },
  methods: {
    onInput(val) {
      if (val) {
        val = moment(new Date(val)).format(this.format);
      }
      this.$emit("input", val);
    },
  },
  mounted() {
    if (this.value && this.value.indexOf("-")) {
      this.input = moment(this.value, this.format).toDate();
    } else {
      this.input = this.value || null;
    }
  },
};
</script>

<style></style>
